export default __webpack_public_path__ + "static/flower_1-f19b22a6890a7259bc3d5aa1ba951a03.png";